exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".button-style[data-v-0b79e1cc]{width:150px;padding:20px;background-color:var(--btn-default)!important}.half[data-v-0b79e1cc]{height:50vh;width:50vw}@media screen and (max-width:991px){.half[data-v-0b79e1cc]{width:100vw!important}}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Map.vue"],"names":[],"mappings":"AACA,+BACE,YAAa,AACb,aAAc,AACd,6CAAgD,CACjD,AACD,uBACE,YAAa,AACb,UAAY,CACb,AACD,oCACA,uBACM,qBAAwB,CAC7B,CACA","file":"Map.vue","sourcesContent":["\n.button-style[data-v-0b79e1cc] {\n  width: 150px;\n  padding: 20px;\n  background-color: var(--btn-default) !important;\n}\n.half[data-v-0b79e1cc] {\n  height: 50vh;\n  width: 50vw;\n}\n@media screen and (max-width: 991px) {\n.half[data-v-0b79e1cc] {\n      width: 100vw !important;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b79e1cc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Map.vue
// module id = 958
// module chunks = 6